import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  customerOpenServiceTicket,
  updateCustomerServiceTicket,
  postCommentCustomerServiceTicket
} from "../../services/serviceticket.js";

@Module({
  namespaced: true
})
export default class ServiceTicket extends VuexModule {
  // state
  openServiceTicket = {};
  storeTicketData = {};

  @Action
  public async openServiceTicketAction() {
    try {
      const data = await customerOpenServiceTicket();
      this.context.commit("setOpenServiceTicket", data.data);
      return data.data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async updateServiceTicketAction(payload) {
    try {
      const data = await updateCustomerServiceTicket(payload);
      return data.response;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async postCommentServiceTicketAction(payload) {
    try {
      const data = await postCommentCustomerServiceTicket(payload);
      return data.response;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async storeServiceTicketData(data) {
    try {
      this.context.commit("setStoreServiceTicketData", data);
    } catch (err) {
      throw err;
    }
  }

  // Mutation
  @Mutation
  public setOpenServiceTicket(data: any) {
    this.openServiceTicket = data;
  }

  @Mutation
  public setStoreServiceTicketData(data: any) {
    this.storeTicketData = data;
  }

  // gatters
  get GetOpenServiceTicket() {
    return this.openServiceTicket;
  }

  get GetStoreServiceTicketData() {
    return this.storeTicketData;
  }
}
